import React from 'react'

export default function Refund() {
    return (
        <div className='md px-12 py-4'>
            <h1 className='text-center mt-6 text-5xl font-bold'>Refund Policy</h1>
            <p className='text-sm mt-5 text-justify'>
                Please read the subscription terms and conditions carefully before subscribing
                to any of the subscription plans, as once you have subscribed you cannot change,
                cancel your subscription plan. Once you subscribe and make the required payment,
                it shall be final and there cannot be any changes or modifications to the same and
                neither will there be any refund.
            </p>

            <p className='text-sm mt-5 text-justify'><b>
            For the courses applicable - Not all courses are covered under Refund policy. Only applicable if there is a refund policy mentioned on the course landing page and checkout page.
            </b>            
            </p>
            <p className='text-sm mt-5 text-justify'>
                We at careerhikers.com want you to be satisfied with your purchase of any of our products.
            </p>
            
            <h2 className='mt-5'><b>
                Cancellation Policy
                </b>                
            </h2>
            <p className='text-sm mt-5 text-justify'>
                We can cancel your purchase/subscription if a request is made within 3 days of placing the order.
                The request has to be made at connect@careerhikers.com with your email ID and phone number used
                during registration. Please keep in mind 33% of the paid amount will be the cancellation charges.
                The remaining amount after deducting the cancellation charges would be refunded to you within 10 days.
                We reserve the right to change the cancellation charges in future without any notice.
            </p>
            
            <h2 className='mt-5'><b>
            Refund Policy
            </b>                
            </h2>
            <p className='text-sm mt-5 text-justify mb-10'>No refund will be provided after 3 days of purchase/subscription of any product/service.
                Refund shall be paid in exceptional cases at the discretion of the management.</p>
        </div>
    );
}